export const LanguageCheckMixins = {
  data() {
    return {
      htmlLang: document.documentElement.lang,
      observer: null,
    };
  },
  computed: {
    languageError() {
      return this.htmlLang !== 'en';
    },
  },
  methods: {
    updateHtmlLang() {
      const newLang = document.documentElement.lang;
      if (newLang !== this.htmlLang) {
        this.htmlLang = newLang;

        if (this.languageError) {
          this.notifyFailure(`Please do not translate this page.`, {
            family: 'LanguageCheck',
            dismissSecs: -1,
            dismissible: true,
            class: 'text-center',
            showInLicensing: true,
          });
        }
      }
    },
  },
  created() {
    this.observer = new MutationObserver(() => {
      this.$nextTick(this.updateHtmlLang);
    });

    this.observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang'],
    });
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
};
